import { useTranslation } from "react-i18next";
import useViewPort from "../../app/hooks/useViewPort";
import { MEDIA_BREAKPOINT_LG } from "../../constants";
import i18n from "../../i18n";
import { setDocumentLang } from "../../utils/helpers";
import Icon from "../icons/Icon";
import { LanguageStrokeIcon } from "../icons/Icons";
import { useUpdateProfileMutation } from "../../services/users/auth";
import { useAdminUpdateOrganizationMutation } from "../../services/organization/settings";

const SwitchLang = ({ fullLabel = false }) => {
  const { t } = useTranslation("common");
  const lang = i18n.language;
  const { width } = useViewPort();

  const isAdmin = localStorage.getItem("is_admin");
  const hasToken = Boolean(localStorage.getItem("token"));
  const useShortLabel = !fullLabel && width <= MEDIA_BREAKPOINT_LG;

  const [updateProfileAdmin] = useAdminUpdateOrganizationMutation();
  const [updateProfileUser] = useUpdateProfileMutation();

  const onChangeLanguage = () => {
    const nextLang = lang === "ar" ? "en" : "ar";
    i18n.changeLanguage(nextLang);
    setDocumentLang(nextLang);

    // Persist to profile only when authenticated (login page is guest)
    if (!hasToken) return;

    if (isAdmin === "true") {
      updateProfileAdmin({ language: nextLang });
    } else {
      updateProfileUser({ language: nextLang });
    }
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
  };

  return (
    <button
      type="button"
      className="btn btn-grey-color font-14 rounded-pill lang"
      onClick={onChangeLanguage}
    >
      <Icon
        icon={<LanguageStrokeIcon />}
        iconColor="#bbbabf"
        hasStroke
        iconSize={useShortLabel ? 15 : 20}
        iconName="language"
        viewBox="0 0 22 22"
        className="me-2"
      />
      <span
        className={`${useShortLabel ? "font_12" : "font_14"}  font-extrabold`}
      >
        {useShortLabel ? t("navbar.shortLang") : t("navbar.lang")}
      </span>
    </button>
  );
};

export default SwitchLang;
